import { render } from "./EditToken.vue?vue&type=template&id=34fa52ab&ts=true"
import script from "./EditToken.vue?vue&type=script&lang=ts"
export * from "./EditToken.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__